import {useCallback, useState} from 'react'

// Dismissal lives in sessionStorage: cleared on logout via StorageHelpers.storageClear()
// (sessionStorage.clear()), so a closed banner reappears on the next login session.
const readDismissed = (key: string): boolean => {
  try {
    return sessionStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

export const UseSessionBanner = (key: string) => {
  const [dismissed, setDismissed] = useState<boolean>(() => readDismissed(key))

  const dismiss = useCallback(() => {
    try {
      sessionStorage.setItem(key, '1')
    } catch {
      // private mode / storage disabled — still hide for the rest of this render session
    }
    setDismissed(true)
  }, [key])

  return {dismissed, dismiss}
}

// Time-window gate. Bounds are timezone-anchored ISO strings, e.g. '2026-09-01T00:00:00-07:00'
// (US Pacific), so the window flips at the intended wall-clock moment regardless of viewer locale.
export const isWithin = (
  start?: string | Date,
  end?: string | Date,
  now: Date = new Date()
): boolean => {
  if (start && now < new Date(start)) return false
  if (end && now > new Date(end)) return false
  return true
}
